module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/19joWSY/tc-custom/9781685507244.jpg?1723405569281",
      "alt": "This image is the cover for the book Murder on the Orion Express"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Murder on the Orion Express\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("After finding a dead man in her office, Hercula Perry simply needs some time away from her job at Hjerson University. When her rich aunt Cynthia books her on the "), _c('i', [_vm._v("Orion Express")]), _vm._v(", the first-of-its-kind tourism transport to the Moon and back, it's not what Hercula had in mind to escape, but she's not about to pass on the opportunity -- or the free food and drink. She takes the chance to get away from it all for a week, only to find things aren't necessarily smoother far above the earth as they are on its surface."), _c('br'), _c('br'), _vm._v("Immediately a passenger dies in suspicious circumstances, pulling Hercula into another questionable death on a ship which won't return home for days. This time, she's determined to figure out what went wrong. This time, she will get to the bottom of it before they return to earth -- or before someone else, maybe even herself, is killed.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Gareth Vaughn\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0